"use client";

import Section from "../Section";
import PostCard from "./PostCard/index";
import Link from "next/link";
import RichText from "payload-pms/RichText";
import { useRouter } from "next/navigation";
import { Tag } from "@/themes/ci/blog/types";

export default function BlogTeaserComponent({
  block,
}: {
  block: BlogTeaserComponentProps;
}) {
  const { posts: inputPosts, title, subheading, btnLabel } = block;

  const posts = inputPosts.length ? inputPosts : [];
  const router = useRouter();

  const renderedPosts = posts.map((post, index) => (
    <PostCard
      key={post.id}
      post={post}
      className="px-3"
      router={router}
      isFirst={index === 0}
    />
  ));

  return (
    <Section
      title={title ? title : "Recent blog posts"}
      className="mb-5 Slider"
    >
      <>
        {subheading && <RichText content={subheading}></RichText>}

        <div className="row">{renderedPosts}</div>

        <div className="row text-center mt-3 mt-lg-4">
          <div className="col-12">
            <Link href="/blog" className="ButtonPrimary">
              {btnLabel ? btnLabel : "All blog posts"}
            </Link>
          </div>
        </div>
      </>
    </Section>
  );
}

type BlogTeaserComponentProps = {
  posts: Post[];
  title?: string;
  btnLabel?: string;
  subheading?: any;
};

export type Post = {
  id: string;
  slug: string;
  titleImage: {
    url: string;
  };
  title: string;
  scheduledAt: string;
  excerpt: string;
  tags: Tag[];
  author: {
    name: string;
  };
};

const SETTINGS = {
  dots: false,
  arrows: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: true,
  swipeToSlide: true,
  speed: 200,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};
